import {titles, subtitles} from "./texts-common-sections";
import {SmallTexts} from "../enums/small-texts";
import {Documents, DocumentsIds} from "./documents";

const urlImages = "/assets/images/modules/section_5/";

export const Section5 = {
  ExplanationTexts: {
    title_expl01: "Ulcères du membre inférieur",
    text_expl01: "<span class='d-block'>Les ulcères du membre inférieur sont des plaies chroniques (cicatrisation > 4" +
      " à 6 semaines) qui siègent sur la partie basse de la jambe (sous le genou) ou sur le" +
      " pied.<sup>1,2</sup></span>" +
      "<span class='d-flex flex-column flex-lg-row gap-3 mt-3'>" +
      "<span class='flex-fill d-flex flex-column gap-3'>" +
      "<img src='" + urlImages + "05sec_ulcere_jambe.png' alt='Ulcère de jambe' />" +
      "<span class='small'>Ulcère de jambe</span></span>" +
      "<span class='flex-fill d-flex flex-column gap-3'>" +
      "<img src='" + urlImages + "05sec_ulcere_pied_diabetique.jpg' alt='Ulcère du pied diabétique'/>" +
      "<span class='small'>Ulcère du pied diabétique</span></span></span>",
    title_expl02: titles.titleUlceresDeJambe,
    text_expl02: "<span class='text-start d-block mb-3'>L’ulcère de jambe se définit comme une " +
      "<span class='fw-bold'>perte de tissu cutané</span> " +
      "concernant l’épiderme, le derme et éventuellement l’hypoderme.<sup>1</sup></span>" +
      "<span class='text-start d-block mb-3'>Il s’agit le plus souvent d’un symptôme d’une " +
      "<span class='fw-bold'>pathologie vasculaire sous-jacente</span>.<sup>2</sup></span>" +
      "<span class='d-block mb-3 text-start'><span class='d-block text-uppercase fw-bold mb-3" +
      " color-green'>Causes&nbsp;:</span>" +
      "<ul>" +
      "<li class='color-red'>Veineuse</li>" +
      "<li class='color-red'>Artérielle</li>" +
      "<li class='color-red'>Mixte</li>" +
      "<li class='color-red'>Microcirculatoire</li>" +
      "</ul></span>" +
      "<span class='text-start d-block mb-3'>L’ulcère de jambe concerne <span class='fw-bold'>2%</span> des patients de" +
      " <span class='fw-bold'>plus de 70 ans</span>.<sup>2</sup></span>",
    title_expl03: titles.titleUlceresDeJambe,
    text_expl03: "<span class='d-block text-uppercase fw-bold'>Ulcère veineux</span>" +
      "<span class='d-block mb-3'>IPS (mmHg)&nbsp;: [0,9 ; 1,3]</span>" +
      "<span class='d-block mb-3 color-red fw-bold'>Facteurs de risques<sup>1-4</sup></span>" +
      "<ul>" +
      "<li class='fw-bold'>Insuffisance veineuse superficielle/profonde (varices, oedème)</li>" +
      "<li class='fw-bold'>Phlébite</li>" +
      "<li>Âge (> 50 ans)&nbsp;; Sexe (féminin)</li>" +
      "<li>Antécédents familiaux</li>" +
      "<li>Antécédents de traumatisme sévère du membre inférieur (exemple&nbsp;: fracture de la cheville)</li>" +
      "<li>Travail en station debout prolongée</li>" +
      "</ul>",
    image_expl03: urlImages + "05sec_ulcere_veineux.jpg",
    annexes_expl03: [
      "<span class='d-block text-start small-text'><span class='fw-bold'>IPS</span>&nbsp;: indice de pression" +
      " systolique</span>",
    ],
    title_expl04: titles.titleUlceresDeJambe,
    text_expl04: "<span class='d-block text-uppercase fw-bold'>Ulcère artériel</span>" +
      "<span class='d-block mb-3'>IPS < 0,6 mmHg</span>" +
      "<span class='d-block mb-3 color-red fw-bold'>Facteurs de risques<sup>1-3</sup></span>" +
      "<ul>" +
      "<li class='fw-bold'>Artériopathie oblitérante du membre inférieur (AOMI)</li>" +
      "<li class='fw-bold'>Hypertension artérielle</li>" +
      "<li class='fw-bold'>Diabète</li>" +
      "<li class='fw-bold'>Obésité</li>" +
      "<li class='fw-bold'>Hypercholestérolémie</li>" +
      "<li class='fw-bold'>Tabac</li>" +
      "<li>Âge (> 50 ans)&nbsp;; Sexe (masculin)</li>" +
      "</ul>",
    image_expl04: urlImages + "05sec_ulcere_arteriel.jpg",
    annexes_expl04: [
      "<span class='d-block text-start small-text'><span class='fw-bold'>IPS</span>&nbsp;: indice de pression" +
      " systolique</span>"
    ],
    title_expl05: titles.titleUlceresDeJambe,
    text_expl05: "<span class='text-start d-block text-uppercase fw-bold mb-3'>Complications" +
      " possibles<sup>1,2</sup></span>" +
      "<ul class='text-start'>" +
      "<li>Eczéma de contact suivant les pansements utilisés</li>" +
      "<li>Surinfection microbienne (augmentation de la douleur, de l’inflammation, fièvre)</li>" +
      "<li>Ostéite (infection osseuse)&nbsp;: ulcères artériels ++</li>" +
      "<li>Ankylose (raideur) de la cheville</li>" +
      "<li>Calcinose&nbsp;: présence de calcifications sous-cutanées pathologiques</li>" +
      "<li>Hémorragie&nbsp;: ulcère veineux ++ (varices)</li>" +
      "<li>Dégénérescence en cancer de la peau</li>" +
      "</ul>",
    title_expl06: titles.titleUlceresDuPiedDiabetique,
    text_expl06: "L’ulcère du pied diabétique est l’une des complications du diabète, survenant dans près de <span" +
      " class='fw-bold'>15 % des cas</span>.<sup>1</sup><br/><br/>" +
      "Il peut se développer n’importe où sur le pied ou la jambe mais principalement sur les zones de forte" +
      " pression (<span class='fw-bold'>orteils, plante, milieu du pied, talon, sous la malléole," +
      " …</span>).<br/><br/>" +
      "Le risque d’amputation d’une jambe, d’un pied ou d’un orteil à cause d’un ulcère est" +
      " <span class='fw-bold'>23 fois plus élevé</span> chez le diabétique que chez le non-diabétique.<sup>2</sup><br/><br/>" +
      "La sévérité des ulcères dus à un diabète a tendance à <span class='fw-bold'>augmenter" +
      " rapidement</span>.<sup>2</sup>",
    image_expl06: urlImages + "05sec_ulcere_pied_diabetique.jpg",
    title_expl07: titles.titleUlceresDuPiedDiabetique,
    text_flex_columns_expl07: [
      {
        group: "85%",
        content: "<span class='text-uppercase color-red fw-bold'>des amputations chez le diabétique sont précédées d’un ulcère<sup>1</sup></span>"
      },
      {
        group: "20%",
        content: "<span class='text-uppercase color-red fw-bold'>des ulcères du pied diabétique de gravité modérée à" +
          " sévère auraient pour issue une amputation (à différents niveaux)" +
          "<sup>2</sup></span>"

      }
    ],
    annexes_expl07: [
      "Il est donc primordial de <span class='color-green fw-bold'>connaître</span> et de <span class='color-green" +
      " fw-bold'>savoir reconnaître</span> les facteurs de risque d’un ulcère du pied diabétique."
    ],
    title_expl08: titles.titleUlceresDuPiedDiabetique,
    text_expl08: "<span class='text-start d-block mb-3 color-red fw-bold'>Facteurs de risques<sup>1,2</sup></span>" +
      "<ul class='text-start'>" +
      "<li><span class='fw-bold'>Neuropathie périphérique</span>&nbsp;: perte de sensibilité qui accroit le risque" +
      " de blessures.<br/>Non détectées, elles peuvent conduire à un ulcère</li>" +
      "<li class='fw-bold'>Antécédent d’ulcère ou d’amputation</li>" +
      "<li class='fw-bold'>Insuffisance artérielle</li>" +
      "<li class='fw-bold'>Déformations des pieds</li>" +
      "<li class='fw-bold'>Troubles visuels</li>" +
      "<li class='fw-bold'>Tabagisme/Alcoolisme</li>" +
      "<li class='fw-bold'>Glycémie non contrôlée</li>" +
      "</ul>" +
      "<span class='text-start mt-3 d-block'>Origine souvent <span class='fw-bold color-green'>mixte</span>," +
      " secondaire à une <span class='fw-bold'>neuropathie diabétique</span> associant perte de sensibilité et" +
      " déformations, à laquelle peut s’ajouter une <span class='fw-bold'>insuffisance artérielle</span> ou une" +
      " <span class='fw-bold'>infection</span>.<sup>1</sup></span>",
    title_expl09: titles.titleUlceresDuPiedDiabetique,
    text_expl09: "<span class='text-start d-block mb-4'>Il est aussi primordial de <span class='fw-bold" +
      " color-green'>connaître</span> et de <span class='fw-bold color-green'>savoir reconnaître</span> les <span" +
      " class='fw-bold'>signes de sévérité</span> de ces ulcères.<sup>1</sup></span>" +
      "<ul class='text-start'>" +
      "<li><span class='fw-bold'>Plaie profonde avec perte tissulaire</span>&nbsp;: augmentation du risque d’infection et d’ostéite</li>" +
      "<li><span class='fw-bold'>Ischémie</span>&nbsp;: fréquent chez les patients diabétiques, complique la prise en charge des ulcères</li>" +
      "<li><span class='fw-bold'>Neuropathie</span>&nbsp;: perte de sensibilité (blessures, déformations du pied) :" +
      " augmente le risque d’ulcère</li>" +
      "<li><span class='fw-bold'>Neuro-ischémie</span>&nbsp;: effet combiné de l’ischémie et de la neuropathie</li>" +
      "<li><span class='fw-bold'>Infection</span>&nbsp;: l’un des principaux contributeurs d’une hospitalisation" +
      " ou d’une amputation chez les diabétiques</li>" +
      "</ul>",
    title_expl10: titles.titleInfosConseils,
    text_expl10: "<span class='d-block fw-bold color-green fw-bold big-text'>" + subtitles.subtitleLeSaviezVous + "</span>" +
      "<span class='mt-3 d-block'>La prise en charge des ulcères est <span class='fw-bold" +
      " color-green'>multifactorielle</span>. Elle repose sur le <span class='fw-bold'>traitement local</span> de la" +
      " plaie (lavage de la plaie, choix du pansement primaire), de l’<span class='fw-bold'>étiologie</span> et des" +
      " <span class='fw-bold'>comorbidités</span> (tabagisme, surpoids, dénutrition, etc.).<sup>1,2</sup></span>" +
      "<span class='mt-3 d-block'>Le pharmacien d’officine, par le biais d’interrogations préventives ou de conseils," +
      " peut <span class='fw-bold'>jouer un rôle</span> dans cette prise en charge.</span>",
    image_expl10: urlImages + "pharmacien_plan rond.png",
    title_expl11: titles.titleInfosConseils,
    text_expl11: "<span class='d-block fw-bold color-green fw-bold big-text'>" + subtitles.subtitleLeSaviezVous + "</span>" +
      "<span class='mt-3 d-block'>La <span class='fw-bold'>compression</span> est une solution indispensable à" +
      " la prise en charge des ulcères de jambe d’atteinte <span class='fw-bold'>veineuse</span> ou <span" +
      " class='fw-bold'>mixte</span> (bandes), sous contrôle médical. Un IPS < 0,6 mmHg contre-indique la compression.<sup>1-3</sup></span>" +
      "<span class='mt-3 d-block'>Selon une étude de 2011, la compression permet une nette amélioration du taux de" +
      " cicatrisation des ulcères veineux de jambe, passant de 29 à 72% de cicatrisation complète" +
      " (p<0,001).<sup>4</sup></span>" +
      "<span class='mt-3 d-block color-green fw-bold small'>" + subtitles.subtitleEnjeuxObservance + "<sup>1,2,5</sup></span>" +
      "<span class='mt-3 d-block small'><span class='fw-bold color-red'>Interrogatoire</span>&nbsp;: rechercher chez" +
      " vos patients les raisons d’une potentielle non-observance.</span>" +
      "<span class='d-block small'><span class='fw-bold color-red'>Rôle éducatif</span>&nbsp;:</span>" +
      "<ul class='small mb-0'>" +
      "<li>rappeler à vos patients <span class='fw-bold'>l’importance d’une compression adaptée sur le long terme</span>.</li>" +
      "<li>préconiser <span class='fw-bold'>la marche</span> autant que possible et la mise en place d’un <span class='fw-bold'>suivi de kinésithérapie</span> (pour éviter l’ankylose de cheville et favoriser le retour veineux).</li>" +
      "</ul>",
    annexes_expl11: [
      "<span class='d-block text-start small-text'><span class='fw-bold'>IPS</span>&nbsp;: indice de pression" +
      " systolique</span>",
    ],
    title_expl12: titles.titleInfosConseils,
    text_expl12: "<span class='d-block fw-bold color-green fw-bold big-text'>" + subtitles.subtitleLeSaviezVous + "</span>" +
      "<span class='mt-3 d-block'>Un système de <span class='fw-bold'>décharge adapté</span> (orthèse" +
      " plantaire, chaussure orthopédique) fait intégralement partie de la prise en charge des <span" +
      " class='fw-bold'>ulcères des pieds diabétiques</span> et\n" +
      "permet la guérison de près de 90 % d’entre eux.<sup>1,2</sup></span>" +
      "<span class='mt-3 d-block color-green fw-bold small'>" + subtitles.subtitleEnjeuxObservance + "<sup>1,2</sup></span>" +
      "<span class='mt-3 d-block small'><span class='fw-bold color-red'>Interrogatoire</span>&nbsp;: rechercher chez" +
      " vos patients les raisons d’une potentielle non-observance.</span>" +
      "<span class='d-block small'><span class='fw-bold color-red'>Conseils</span>&nbsp;:</span>" +
      "<ul class='small mb-0'>" +
      "<li>Recommander une <span class='fw-bold'>inspection quotidienne des pieds</span></li>" +
      "<li><span class='fw-bold'>Limiter la marche au strict minimum</li>" +
      "<li><span class='fw-bold'>Éviter de marcher pieds nus</li>" +
      "<li>Encourager un <span class='fw-bold'>suivi par un podologue</span></li>" +
      "</ul>",
    title_expl13: titles.titleInfosConseils,
    text_expl13: "<span class='fw-bold'>Votre rôle de conseil</span> s’applique dans la prise en charge de l’ulcère à" +
      " proprement parler, mais peut aussi aller au-delà.",
    list_buttons_expl13: [
      {
        group: "",
        title: "Conseils hygiéno-diététiques",
        content: [
          {
            text: "<span class='mt-3 d-block'><span class='color-red fw-bold'>ÉTAT NUTRITIONNEL</span>&nbsp;:" +
              " prévenir une éventuelle dénutrition.<sup>1-3</sup></span>" +
              "<span class='mt-3 d-block'>La dénutrition peut-être responsable d’un <span class='fw-bold'>retard de" +
              " cicatrisation</span>.</span>" +
              "<span class='mt-3 d-block fw-bold color-green'>Conseils nutritionnels</span>" +
              "<ul class='mt-3 mb-0'>" +
              "<li><span class='fw-bold'>Adopter une alimentation bien rythmée, régulière et" +
              " enrichie&nbsp;: 3 repas/jour</span> (possibilité de fractionner les repas en prenant des" +
              " collations entre les repas)</li>" +
              "<li><span class='fw-bold'>Enrichir son alimentation</span>&nbsp;: privilégier les <span" +
              " class='fw-bold'>produits riches en énergie et/ou en protéines</span> sans restreindre les produits" +
              " <span class='fw-bold'>gras et sucrés</span> (hormis contre-indication médicale). Il est autorisé de" +
              " <span class='fw-bold'>grignoter</span></li>" +
              "<li><span class='fw-bold'>Stimuler son appétit</span>&nbsp;: pratiquer une activité physique," +
              " parfumer ses plats (épices, sel, herbes aromatiques) en respectant les contre-indications médicales</li>" +
              "<li><span class='fw-bold'>Éviter une période de jeune nocturne</span> trop longue (>12 h)</li>" +
              "</ul>" +
              "<span class='mt-3 d-block'>Si besoin, des compléments nutritionnels oraux peuvent être prescrits par le médecin.</span>" +
              "<span class='mt-5 d-block'><span class='color-red fw-bold'>ARRÊT DU TABAC<sup>1</sup></span></span>" +
              "<span class='mt-3 d-block'>Le tabac étant un facteur de risque de développer des ulcères.</span>" +
              "<span class='mt-5 d-block'><span class='color-red fw-bold'>ACTIVITÉ PHYSIQUE<sup>2</sup></span></span>" +
              "<span class='mt-3 d-block'>Dans le cas des ulcères de jambes, il convient d’encourager les patients à" +
              " pratiquer une <span class='fw-bold'>activité physique</span> et de favoriser la <span" +
              " class='fw-bold'>marche</span> au besoin avec l’aide d’un kinésithérapeute.</span>",
            small_texts: {
              1: SmallTexts.AMPlaiesChroniques,
              2: SmallTexts.LomigLeBihan,
              3: SmallTexts.AMAmaigrissement
            }
          }
        ],
      },
      {
        group: "",
        title: "Vaccin",
        content: [
          {
            title: "<span class='big-text'>Vaccination antitétanique<sup>1,2</sup></span>",
            text: "<ul class='mb-3'>" +
              "<li>Demander à votre patient si sa vaccination antitétanique est à jour.</li>" +
              "<li>Le rediriger vers son médecin si besoin.</li>" +
              "</ul>",
            small_texts: {
              1: SmallTexts.AMPlaiesChroniques,
              2: SmallTexts.HospicesCivilsLyon,
            }
          }
        ],
      },
      {
        group: "",
        title: "Suivi psychologique",
        content: [
          {
            title: "<span class='big-text'>Vivre avec/après un ulcère<sup>1</sup></span>",
            text: "<span class='mb-3 d-block'>Un ulcère peut avoir de lourdes répercutions sur la qualité de vie des" +
              " patients.</span>" +
              "<ul class='mb-3'>" +
              "<li>Rappeler à vos patients qu’un <span class='fw-bold'>suivi psychologique</span> peut-être proposé le cas échéant.</li>" +
              "</ul>",
            small_texts: {
              1: SmallTexts.HospicesCivilsLyon,
            }
          }
        ],
      }
    ],
    annexes_q03: [
      "<span class='d-block text-start small-text'><span class='fw-bold'>IPS</span>&nbsp: indice de pression" +
      " systolique</span>"
    ],
  },
  Responses: {
    additional_text_title_q01: "<sup>1-3</sup>",
    title_correct_q01: "Bravo&nbsp;!",
    title_not_correct_q01: "Vous pouvez faire mieux que ça&nbsp;!",
    text_q01: "Certaines étiologies augmentent le risque de développer des ulcères de jambe chez vos patients.<br/>" +
      "Une prise en charge précoce étant associée à une meilleure guérison, nous vous recommandons de prêter" +
      " particulièrement attention aux patients les plus à risque.",
    title_correct_q02: "Oui&nbsp;!",
    title_not_correct_q02: "Pourtant, si&nbsp;!",
    text_q02: "Une neuropathie périphérique, un trouble de la circulation sanguine ou une glycémie non contrôlée" +
      " sont autant de facteurs de risque de développer un ulcère.<sup>1,2</sup>",
    title_correct_q03: "Vous évitez cette fourchette royale&nbsp;!",
    title_not_correct_q03: "Une position difficile, la partie continue&nbsp;!",
    text_correct_q03:"La compression est en effet requise pour la prise en charge des ulcères " +
      "<span class='fw-bold'>veineux</span>.<sup>1</sup>",
    text_not_correct_q03: "L’artériopathie oblitérante du membre inférieur (AOMI), avec un IPS < 0,6 mmHg, est une" +
      " pathologie vasculaire artérielle. Or la compression est requise pour la prise en charge des <span" +
      " class='fw-bold'>ulcères veineux</span>.<sup>1</sup>",
    title_correct_q04: "BRAVO, vous n’êtes pas tombé dans le piège&nbsp;!",
    title_not_correct_q04: "Il y avait un piège&nbsp;!",
    text_q04: "Dans le cas d’un ulcère du pied diabétique, il convient de limiter la marche " +
      "<span class='fw-bold'>autant que possible</span>.<sup>1</sup>",
  },
  EndTexts: {
    image_end01: urlImages + "05sec01end_img.png",
    title_end01: "Félicitations, les ulcères des membres inférieurs n’ont plus de secret pour vous&nbsp;!",
    text_end01_p01: "Ces connaissances vous seront utiles et permettront de favoriser une prise en charge d’une part précoce et d’autre part plus globale, incluant les conseils associés aux comorbidités.",
    text_end01_p02: "Avant de continuer la partie, téléchargez <a class='doc-download' href='" + Documents.Document5 + "' data-document-id='" + DocumentsIds.Document5 + "' target='_blank'>une fiche récapitulative</a> de ce module.",
    text_end01_p03: "Pour aller plus loin, écoutez nos <a href='https://www.lohmann-rauscher.com/fr-fr/podcast-rosidal/' target='_blank'>podcasts interactifs (histoires cliniques) «&nbsp;Ne pas poser la bande à côté&nbsp;»</a> et découvrez notre <a href='https://prod10.almedia.fr/lr_3d/' target='_blank'>Serious Game</a>.",
  },
};
